import Promise from 'Promise';
import loadjs from 'loadjs';
import $ from '@get-bridge/learn-legacy-shared/dist/utils/jquery';
import prependAssetPrefix from './prependAssetPrefix';

export function fetchManifest(app) {
  return $.ajax({
    url: prependAssetPrefix(app, app.manifest),
    cache: false,
  });
}

export function loadAssets(app, assets) {
  if (!loadjs.isDefined(app.name)) {
    const scriptPaths = app.scripts
      .filter(path => assets.hasOwnProperty(path))
      .map(path => prependAssetPrefix(app, assets[path]));

    app.stylesheets
      .filter(path => assets.hasOwnProperty(path))
      .map(path => prependAssetPrefix(app, assets[path]))
      .forEach(path => {
        let element = document.createElement('link');
        element.href = path;
        element.media = 'all';
        element.rel = 'stylesheet';
        document.head.appendChild(element);
      });

    return loadjs(scriptPaths, app.name, { returnPromise: true }).catch(
      depsNotFound => {
        throw new Error('Failed to load assets', depsNotFound);
      },
    );
  }
  return Promise.resolve();
}



// WEBPACK FOOTER //
// ./jsapp/learnRuntime/assets.js